import { bl_fi_packing_order_packed_bins_RowClass, bl_fi_packing_order_packed_bins_RowInterface } from '../../../dbschema';
import { BaseContainerModel } from '../../base-container.model';
import * as fromDatatype from '../../../datatype-library/index';

export class AvailablePackedBinsContainerModel extends BaseContainerModel {
  packed_bins: bl_fi_packing_order_packed_bins_RowInterface =
    new bl_fi_packing_order_packed_bins_RowClass();
  container_measure: fromDatatype.NumericDatatypeInterface;
  container_uom: fromDatatype.VarcharDatatypeInterface;
  container_width: fromDatatype.NumericDatatypeInterface;
  bin_hdr_code: fromDatatype.VarcharDatatypeInterface;
  bin_line_code: fromDatatype.VarcharDatatypeInterface;
  item_guid: fromDatatype.GuidDataFieldInterface;
}